//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReportFormat, ReportType } from './Enums';

export abstract class ReportInputItem extends ItemBase {
    AutoDelete: boolean = false;
    Format: ReportFormat = ReportFormat.PDF;
    Note: string | null = null;
    abstract readonly Type: ReportType;

    static readonly ClassName: string = "ReportInputItem";
}
